import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';

export const AccordionSectionTitle = styled(Typography)(({ theme }) => ({
  ...theme.typography.h6,
  color: theme.palette.text.primary,
  display: 'flex',
  alignItems: 'center',
  gap: theme.palette.tokens.space[3],
  margin: `${theme.palette.tokens.space[5]}px 0`,
  cursor: 'pointer',
  userSelect: 'none',
  '& span': { fontSize: '22px', color: theme.palette.text.secondary },
}));
